import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import "../../styles/TomatePoivron.css"

const TomatePoivron = ({ dark, setDark, sidebarOpen, setSidebarOpen }) => {
    const [cookies] = useCookies(["token"]);
    const [seasons, setSeasons] = useState([]);
    const [loading, setLoading] = useState(true);
    const toggleTheme = () => setDark(!dark);

    const [showSeasonDrawer, setShowSeasonDrawer] = useState(false);
    const [seasonYear, setSeasonYear] = useState("");


    const navigate = useNavigate();

    const [reminders, setReminders] = useState([]);
    const decodeToken = (token) => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch {
            return null;
        }
    };

    const [user, setUser] = useState(null);

    useEffect(() => {
        if (!cookies.token) return;

        const decoded = decodeToken(cookies.token);
        setUser(decoded); // contient { id, username, role, ... }
    }, [cookies.token]);

    useEffect(() => {
        fetch("https://api.industriegaming.fr/api/garden/reminders", {
            headers: { Authorization: `Bearer ${cookies.token}` }
        })
            .then(res => res.json())
            .then(data => setReminders(data));
    }, []);

    const fetchSeasons = async () => {
        try {
            const res = await fetch("https://api.industriegaming.fr/api/garden/seasons", {
                headers: {
                    Authorization: `Bearer ${cookies.token}`,
                },
            });

            const data = await res.json();
            setSeasons(data);
        } catch (err) {
            console.error("Erreur fetch saisons :", err);
        } finally {
            setLoading(false);
        }
    };

    function getReminderIcon(type) {
        switch (type) {
            case "rempotage": return "🪴";
            case "pot": return "🌱";
            case "note": return "📝";
            case "arrosage": return "💧";
            case "parasites": return "🐛";
            case "repiquage": return "🌿";
            case "temperature": return "❄️";
            default: return "🔔";
        }
    }

    const activeSeasons = seasons.filter(s => !s.archived);
    const archivedSeasons = seasons.filter(s => s.archived);

    const saveSeason = async () => {
        try {
            await fetch("https://api.industriegaming.fr/api/garden/addSeasons", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${cookies.token}`,
                },
                body: JSON.stringify({
                    year: seasonYear
                }),
            });

            setShowSeasonDrawer(false);
            setSeasonYear("");

            fetchSeasons(); // recharge la liste
        } catch (err) {
            console.error(err);
        }
    };


    useEffect(() => {
        fetchSeasons();
    }, []);

    const openSeason = (id) => {
        navigate(`/season/${id}`);
    };

    const openAddSeason = () => {
        setShowSeasonDrawer(true);
    };

    if (loading) {
        return (
            <div className={`dashboard ${dark ? "dark" : ""}`}>
                <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>
                <div className="main">
                    <Topbar onToggleSidebar={() => setSidebarOpen(true)} onToggleTheme={toggleTheme} dark={dark} />
                    <div className="garden-page">
                        <p>Chargement...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>

            <div className="main">
                <Topbar onToggleSidebar={() => setSidebarOpen(true)} onToggleTheme={toggleTheme} dark={dark} />

                <div className="garden-page">

                    {/* HEADER */}
                    <div className="users-header">
                        <div className="users-header-logo">
                            <h1>Jardinage</h1>
                        </div>

                        {user?.role === "Admin" && (
                            <button className="add-user-btn" onClick={openAddSeason}>
                                + Ajouter une saison
                            </button>
                        )}
                    </div>

                    {reminders.length > 0 && (
                        <div className="reminders-box">
                            <h3>🔔 Rappels du jour</h3>

                            <ul>
                                {reminders.map((r, i) => (
                                    <li key={i} className={`reminder-item reminder-${r.type}`}>
                                        <span className="reminder-icon">{getReminderIcon(r.type)}</span>
                                        {r.message}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* TABLE DES SAISONS */}
                    <h2>Saisons en cours</h2>

                    <div className="users-table-wrapper">
                        <table className="users-table">
                            <thead>
                            <tr>
                                <th>Année</th>
                                <th>Semis</th>
                                <th>Notes</th>
                                <th>Photos</th>
                                <th>Actions</th>
                            </tr>
                            </thead>

                            <tbody>
                            {activeSeasons.map((s) => (
                                <tr key={s.id}>
                                    <td>{s.year}</td>
                                    <td>{s.GardenSemis?.length || 0}</td>
                                    <td>{s.GardenNotes?.length || 0}</td>
                                    <td>{s.GardenPhotos?.length || 0}</td>

                                    <td className="actions">
                                        <button onClick={() => openSeason(s.id)}>📖</button>
                                    </td>
                                </tr>
                            ))}

                            {/*{Array.from({length: Math.max(10 - activeSeasons.length, 0)}).map((_, i) => (*/}
                            {/*    <tr key={`empty-${i}`} className="empty-row">*/}
                            {/*        <td colSpan="5"></td>*/}
                            {/*    </tr>*/}
                            {/*))}*/}
                            </tbody>
                        </table>
                    </div>

                    <h2>Saisons archivées</h2>

                    <div className="users-table-wrapper archived">
                        <table className="users-table">
                            <thead>
                            <tr>
                                <th>Année</th>
                                <th>Semis</th>
                                <th>Notes</th>
                                <th>Photos</th>
                                <th>Actions</th>
                            </tr>
                            </thead>

                            <tbody>
                            {archivedSeasons.map((s) => (
                                <tr key={s.id} className="archived-row">
                                    <td>{s.year}</td>
                                    <td>{s.GardenSemis?.length || 0}</td>
                                    <td>{s.GardenNotes?.length || 0}</td>
                                    <td>{s.GardenPhotos?.length || 0}</td>

                                    <td className="actions">
                                        <button onClick={() => openSeason(s.id)}>📖</button>
                                    </td>
                                </tr>
                            ))}

                            {Array.from({length: Math.max(10 - archivedSeasons.length, 0)}).map((_, i) => (
                                <tr key={`empty-archived-${i}`} className="empty-row">
                                    <td colSpan="5"></td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
            {showSeasonDrawer && (
                <div className="drawer-overlay">
                    <div className="drawer">
                        <h2>Ajouter une saison</h2>

                        <div className="drawer-field">
                            <label>Année</label>
                            <input
                                type="text"
                                value={seasonYear}
                                onChange={(e) => setSeasonYear(e.target.value)}
                            />
                        </div>

                        <div className="drawer-actions">
                            <button className="edit-glass-btn" onClick={saveSeason}>
                                Enregistrer
                            </button>
                            <button className="edit-glass-btn" onClick={() => setShowSeasonDrawer(false)}>
                                Annuler
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default TomatePoivron;
